import { checkMcpToolsReady } from './mcpToolsAdapter'

export type McpBridgeStatus =
  | { ready: true; availableTools: string[] }
  | { ready: false; availableTools: string[]; error?: string }

let cachedStatus: McpBridgeStatus | undefined
let lastCheck = 0

const CACHE_TTL_MS = 30_000

export const clearMcpStatusCache = () => {
  cachedStatus = undefined
  lastCheck = 0
}

export const getMcpStatus = async (): Promise<McpBridgeStatus> => {
  const now = Date.now()
  if (cachedStatus && now - lastCheck < CACHE_TTL_MS) return cachedStatus

  const result = await checkMcpToolsReady()
  cachedStatus = result.ready
    ? { ready: true, availableTools: result.availableTools }
    : { ready: false, availableTools: result.availableTools, error: result.error }
  lastCheck = now
  return cachedStatus
}
